import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { MdEmail } from 'react-icons/md';
import { FaGithub, FaLinkedin } from 'react-icons/fa';
import Button from './Button';
import cvData from '../data/data.json';

const Header = () => {
  const { personalInfo, socialLinks } = cvData;

  return (
    <header style={{
      background: 'linear-gradient(to right, #1a1a1a, #0a192f)',
      color: '#8892b0',
      padding: '100px 0',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center'
    }}>
      <Container>
        <Row className="justify-content-center text-center">
          <Col lg={8}>
            <h1 style={{ 
              color: '#ccd6f6', 
              fontSize: '3.5rem', 
              marginBottom: '1rem',
              fontWeight: '600'
            }}>
              {personalInfo.name}
            </h1>
            <h2 style={{ 
              color: '#64ffda', 
              fontSize: '2rem', 
              marginBottom: '2rem',
              fontWeight: '500'
            }}>
              {personalInfo.title}
            </h2>
            <p style={{ 
              fontSize: '1.2rem', 
              marginBottom: '2rem',
              lineHeight: '1.6'
            }}>
              {personalInfo.summary}
            </p>
            <div style={{ marginTop: '2rem' }}>
              <Button href={`mailto:${personalInfo.email}`} icon={MdEmail}>
                Email
              </Button>
              <Button href={socialLinks.github} target="_blank" rel="noopener noreferrer" icon={FaGithub}>
                GitHub
              </Button>
              <Button href={socialLinks.linkedin} target="_blank" rel="noopener noreferrer" icon={FaLinkedin}>
                LinkedIn
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </header>
  );
};

export default Header; 